import { request } from "../";
import config from "../../../config/common";
import { CATEGORY_DETAILS_REQUEST, CATEGORY_REQUEST } from "../constants";
import getCategoryApiBaseUrl from "./getCategoryApiBaseUrl";
import getCategoryApiDefaults from "./getCategoryApiDefaults";
import filterCategories from "./filterCategories";
import getFacetedNavigationParams from "./getFacetedNavigationParams";
import ErrorMessage from "../../../components/ErrorMessage";

const {
  api: {
    category: { timeout, details }
  }
} = config;

const requestTimeout = parseInt(timeout, 10);

export const getCategory = ({
  country,
  language,
  query: { cid },
  uuid,
  xSiteOrigin,
  displayableChildLinkCount,
  formatTranslation
}) => {
  const baseUrl = getCategoryApiBaseUrl(xSiteOrigin);

  if (!cid) {
    return <ErrorMessage status={404} formatTranslation={formatTranslation} />;
  }

  const queryString = new URLSearchParams(
    getCategoryApiDefaults({ country, language, baseUrl, xSiteOrigin })
  ).toString();

  const url = `${baseUrl}${cid}?${decodeURIComponent(queryString)}`;
  const options = {
    timeout: requestTimeout
  };
  const requestType = CATEGORY_REQUEST;

  return request(url, options, requestType, uuid).then(apiResponse =>
    filterCategories({ apiResponse, displayableChildLinkCount })
  );
};

export const getCategoryDetails = ({
  country,
  language,
  query: { cid, refine },
  uuid,
  xSiteOrigin,
  loyaltyTier
}) => {
  const baseUrl = getCategoryApiBaseUrl(xSiteOrigin);

  const combinedParams = {
    ...(refine ? getFacetedNavigationParams({ refine }) : {}),
    ...getCategoryApiDefaults({
      country,
      language,
      baseUrl,
      xSiteOrigin,
      loyaltyTier
    })
  };

  const queryString = new URLSearchParams(combinedParams).toString();
  const url = `${baseUrl}${cid}${details}?${queryString}`;
  const options = { timeout: requestTimeout };
  const requestType = CATEGORY_DETAILS_REQUEST;

  return request(url, options, requestType, uuid);
};
